import { h } from 'preact';
import style from './style';

export const GlowButton = props => {
  const Tag = props.href ? 'a' : 'button';
  return (
    <Tag
      {...props}
      class={`${style.bookButton} ${style.hoverGlow} ${
        props.glow ? style.glow : ''
      }${props.disabled ? ` ${style.disabled}` : ''}${
        props.loading ? ` ${style.loading}` : ''
      }${props.class ? ' ' + props.class : ''}`}
    >
      <span class={style.children}>{props.children}</span>
    </Tag>
  );
};

export const RoundButton = props => {
  const Tag = props.href ? 'a' : 'button';
  return (
    <Tag
      {...props}
      class={`${style.bookButton} ${
        props.disabled ? ` ${style.disabled}` : ''
      }${props.loading ? ` ${style.loading}` : ''}${
        props.class ? ' ' + props.class : ''
      }`}
    >
      <span class={style.children}>{props.children}</span>
    </Tag>
  );
};

export const Button = props => {
  const Tag = props.href ? 'a' : 'button';
  return (
    <Tag
      {...props}
      class={`${style.button}${props.disabled ? ` ${style.disabled}` : ''}${
        props.loading ? ` ${style.loading}` : ''
      }${props.class ? ' ' + props.class : ''}`}
    >
      <span class={style.children}>{props.children}</span>
    </Tag>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./components/button/index.js